var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickToFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.543535 9.07498C1.00038 8.14468 2.19611 7.86815 3.01502 8.50342L5.57563 10.4898C6.06058 10.866 6.75125 10.8157 7.17648 10.3731L16.045 1.14263C16.6704 0.491701 17.6848 0.413838 18.4022 0.961692C19.2507 1.6096 19.3393 2.85448 18.5913 3.61612L8.04303 14.3562C7.14093 15.2747 5.67481 15.3178 4.72028 14.4539L0.91425 11.0093C0.373001 10.5194 0.221755 9.73025 0.543535 9.07498Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickToFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick-to-fill.642907cc77be53feddffa54862e8de1e.svg";